const translations = {
  "en": {
    "Close": "Close",
    "Manage subscription": "Manage subscription",
    "Not now": "Not now",
    "To pay with this method, first turn off auto-renew on your current subscription. You'll keep your benefits until the end of the current period.": "To pay with this method, first turn off auto-renew on your current subscription. You'll keep your benefits until the end of the current period.",
    "You already have an active subscription": "You already have an active subscription",
    "Your current subscription uses a different payment method.": "Your current subscription uses a different payment method."
  },
  "zh-tw": {
    "Close": "關閉",
    "Manage subscription": "管理訂閱",
    "Not now": "暫時不要",
    "To pay with this method, first turn off auto-renew on your current subscription. You'll keep your benefits until the end of the current period.": "若要改用此方式付款，請先關閉目前訂閱的自動續訂。您的權益會保留至本期結束。",
    "You already have an active subscription": "您已有生效中的訂閱",
    "Your current subscription uses a different payment method.": "您目前的訂閱使用的是另一種付款方式。"
  }
};

export default translations;
